const Modal = require("ui-modal");
const $ = require("lc-jquery");
const _has = require("lodash.has");
const FormValidator = require("ui-form-validator");
const v = require("ui-validator");
const validators = v.validators;
const processingModal = new Modal($("#processingModal"), { keyboard: false, backdrop: "static" });

function LoginForm() {
  this.loginForm = $("#login_form");
  this.globalErrorEle = $("#global-error");
  this.opts = getFormOptions();
  this.formValidator = new FormValidator(this.loginForm, this.opts);
  this.isLoginPage = this.formValidator.getModel()["login-page"];
  this.isLoginModal = this.formValidator.getModel()["login-modal"];
  this.registerEvents();
}

function getFormOptions() {
  return {
    schema: {
      email: [validators.email({}), validators.required({})],
      password: validators.required({}),
    },
    transformFunction: function (obj) {
      if (obj.email && typeof obj.email === "string") {
        obj.email = obj.email.trim();
      }
      return obj;
    },
  };
}

LoginForm.prototype.registerEvents = function () {
  this.formValidator.on("success", $.proxy(this.successHandler, this));
  this.formValidator.on("error", $.proxy(this.errorHandler, this));
};

LoginForm.prototype.updateError = function (msg) {
  this.cleanUpErrors();
  this.globalErrorEle.html(msg).removeClass("hidden");
};

LoginForm.prototype.successHandler = function (formData) {
  var self = this;
  var postData = {
    email: formData.email,
    password: formData.password,
  };
  if (self.processing) {
    return;
  }

  self.processing = true;
  processingModal.show();
  $.ajax({
    url: "/login",
    type: "POST",
    data: postData,
  })
    .done(function (data, textStatus, xhr) {
      if (data && data.redirect) {
        location.href = data.redirect;
      } else {
        self.updateError(
          "The information you entered doesn't match our records. Try again, or <a href='/reset-password'> reset your password.</a>",
        );
      }
    })
    .fail(function (xhr) {
      self.handlePostError(xhr);
    })
    .always(function () {
      self.processing = false;
      processingModal.hide();
    });
};

LoginForm.prototype.handlePostError = function (xhr) {
  if (xhr.status === 401) {
    if (this.isLoginPage || this.isLoginModal) {
      this.updateError(
        "The information you entered doesn't match our records. Try again, or <a href='/reset-password'> reset your password.</a>",
      );
    } else {
      window.location = "/login?error=unauthorized";
    }
  } else if (xhr.status === 403) {
    if (this.isLoginPage || this.isLoginModal) {
      this.updateError(
        "The information you entered doesn't match our records. For your security, we have locked your account. You can try again in 15 minutes, or <a href='/reset-password'> reset your password.</a>",
      );
    } else {
      window.location = "/login?error=locked";
    }
  } else if (_has(xhr, "responseJSON.errors.password.validPassword")) {
    // the post request didn't pass the validation in login-schema due to invald password structure. Boreas returns status === 400 (Bad Request)
    if (xhr.responseJSON.errors.password.validPassword === "Invalid Password") {
      window.location = "/login?error=unauthorized";
    }
  } else {
    window.location = "/login?error=system";
  }
};

LoginForm.prototype.cleanUpErrors = function () {
  this.globalErrorEle.addClass("hidden");
  var key;
  if (this.isLoginModal) {
    for (key in this.opts.schema) {
      if ($(".modal-" + key + "-error")) {
        $(".modal-" + key + "-error").addClass("hidden");
      }
      if ($(".modal-" + key)) {
        $(".modal-" + key).removeClass("invalid");
      }
    }
  } else {
    for (key in this.opts.schema) {
      if ($("#" + key + "-error")) {
        $("#" + key + "-error").addClass("hidden");
      }
      if ($("#" + key)) {
        $("#" + key).removeClass("invalid");
      }
    }
  }
};

LoginForm.prototype.errorHandler = function (errors) {
  if (!this.isLoginPage && !this.isLoginModal) {
    window.location = "/login?error=unauthorized";
    return;
  }
  this.cleanUpErrors();
  var key;

  if (this.isLoginModal) {
    for (key in errors) {
      if ($(".modal-" + key + "-error")) {
        $(".modal-" + key + "-error").removeClass("hidden");
      }
      if ($(".modal-" + key)) {
        $(".modal-" + key).addClass("invalid");
      }
    }
  } else {
    for (key in errors) {
      if ($("#" + key + "-error")) {
        $("#" + key + "-error").removeClass("hidden");
      }
      if ($("#" + key)) {
        $("#" + key).addClass("invalid");
      }
    }
  }
};

new LoginForm();
module.exports = {};

require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/src/shared_modules/login/login.less');